const LAST_UPDATED_DATE = 'December 14, 2025';

export const ScheduleA = () => {
  return (
    <div className="text-left bg-white py-24 sm:py-32 flex-grow">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <h2 className="text-base/7 font-semibold text-primary-50">Legal</h2>
        <p className="mt-2 text-4xl font-semibold tracking-tight text-grey-100 sm:text-5xl">
          Schedule A: Unblinding &amp; Non-Circumvention Agreement
        </p>
        <div className="mt-10 space-y-8 text-base/7 text-grey-300">
          <p>Last updated: {LAST_UPDATED_DATE}</p>

          <p className="text-grey-300">
            This Schedule A applies when the Platform offers or enforces a "blinded" workflow (e.g.,
            hidden identity or contact information). It is accepted by click‑wrap at the time of the
            unblinding request and again by the counterparty if they accept unblinding.
          </p>

          {/* A1 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">A1. Definitions</h3>
            <ul className="list-disc pl-5 mt-2 text-grey-300 space-y-1">
              <li>
                "Unblinding" means revealing identity and/or contact information of one User to
                another within the Platform.
              </li>
              <li>"Initiator" means the User requesting Unblinding.</li>
              <li>"Counterparty" means the User whose information would be revealed.</li>
              <li>
                "Covered Relationship" means any direct or indirect commercial, employment,
                staffing, contracting, consulting, referral, or other business relationship between
                Initiator and Counterparty that arises from or is facilitated by Platform
                interactions.
              </li>
            </ul>
          </div>

          {/* A2 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">
              A2. Request and Mutual Acceptance
            </h3>
            <p className="mt-2 text-grey-300">
              Initiator may request Unblinding. The Platform will notify the Counterparty.
              Unblinding occurs only if the Counterparty affirmatively accepts. If the Counterparty
              declines, Unblinding will not occur and the parties must continue blinded
              communications through the Platform (if available).
            </p>
          </div>

          {/* A3 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">
              A3. Triggered Obligations Upon Mutual Acceptance
            </h3>
            <p className="mt-2 text-grey-300">
              If both parties accept Unblinding, then for the applicable "Restricted Period" below:
              (i) the parties will not circumvent the Platform, (ii) the Covered Relationship (at
              any level) remains subject to Platform fees and enforcement, and (iii) each party
              agrees the Platform may use credentialing, identity, and compliance tools (including
              automated analysis) to monitor and enforce compliance.
            </p>
          </div>

          {/* A4 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">A4. Restricted Period</h3>
            <p className="mt-2 text-grey-300">
              Restricted Period: six (6) months from the date/time of mutual acceptance, unless an
              Order Form, fee schedule, or negotiated enterprise contract sets a longer period for
              that relationship.
            </p>
          </div>

          {/* A5 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">A5. Fees Owed; Invoicing</h3>
            <p className="mt-2 text-grey-300">
              If a Covered Relationship results in fees under the Fee Schedule or an Order Form,
              those fees are owed regardless of whether the parties later execute separate contracts
              outside the Platform. Company may invoice either or both parties as specified by the
              Fee Schedule/Order Form.
            </p>
          </div>

          {/* A6 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">
              A6. Breach; Remedies; Attorneys' Fees
            </h3>
            <p className="mt-2 text-grey-300">
              If either party circumvents or attempts to circumvent Platform fees or obligations:
              (i) Company may terminate or suspend accounts; (ii) Company may pursue payment of all
              fees owed; (iii) Company may seek injunctive relief; and (iv) the breaching party(ies)
              will be responsible for Company's reasonable attorneys' fees and costs to enforce this
              Schedule A, to the extent permitted by law.
            </p>
          </div>

          {/* A7 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">A7. Evidence; Logs</h3>
            <p className="mt-2 text-grey-300">
              You consent to Company maintaining records and audit logs sufficient to demonstrate
              acceptance, timestamps, and relevant transaction events.
            </p>
          </div>

          {/* A8 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">
              A8. Click‑wrap Acceptance Language (UI text)
            </h3>
            <div className="mt-2 text-grey-300 space-y-2">
              <p>
                The following language may be presented in a modal at the time of acceptance
                (example):
              </p>
              <p>
                <strong>Modal Title:</strong> Request to Share Contact Information
              </p>
              <p>
                <strong>Body (short summary):</strong> By clicking "I Agree &amp; Request
                Unblinding," you are electronically signing and agreeing to the Marketplace AI
                Master Terms and Schedule A (Unblinding &amp; Non-Circumvention). If the other party
                accepts, any relationship or transaction between you and the other party arising
                from the Platform will be subject to Marketplace AI fees and enforcement for at
                least 6 months. Attempts to bypass fees may result in removal from the Platform,
                legal action, and responsibility for attorneys' fees. See the full agreement via
                "View Terms."
              </p>
              <p>
                <strong>Buttons:</strong>
              </p>
              <ul className="list-disc pl-5 mt-1 space-y-1">
                <li>Primary: "I Agree &amp; Request Unblinding"</li>
                <li>Secondary: "Cancel"</li>
                <li>
                  Link: "View Terms" (opens Master Terms + Schedule A in a new window or in-app
                  view)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
